<script setup lang="ts">
import { ComparisonId } from '~/enums/course.enums';
import { QuizType } from '@/enums/quiz.enums';
import type { LocalesType } from "~/enums/localization.enums";

const route = useRoute();
const { virtualPageView } = useTracking();
const {
  loadQuiz,
  quiz,
  onQuizFinished,
} = useQuizStore();
const {
  getActivity,
  getActivityUrl,
} = useCourseState();
const { t, locale } = useI18n();
const localePath = useLocalePath();

virtualPageView('course', 'quiz');

definePageMeta({
  layout: 'empty',
  name: 'quiz',
  middleware: 'course-activity-access-middleware',
});

const isLoading = ref(false);

const isLocked = computed(() => {
  const quizId = route.params.quizId as string;
  const activity = getActivity(quizId);
  return activity?.locked ?? true;
});

onMounted(async () => {
  isLoading.value = true;

  try {
    if (isLocked.value) { return; }
    await loadQuiz(route.params.quizId as string, locale.value as LocalesType);

    useHead({
      title: `${quiz.value?.title || t('meta.course.quiz.title')}`,
    });
  } catch(e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
});

const doMasteryQuizRedirect = async () => {
  const activity = getActivity(ComparisonId.toString());

  if (activity) {
    activity.locked = false;

    const url = getActivityUrl(activity);
    await navigateTo(localePath(url as string), { replace: true });
  }
};

onQuizFinished(quiz => {
  if (quiz.type === QuizType.Mastery) {
    doMasteryQuizRedirect();
  }
});
</script>

<template>
  <Quiz v-if="!isLoading && quiz" />
</template>